import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import User from "../../services/user.service";
export var getCurrentUser = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, payload) {
    var commit, state, user;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          commit = _ref.commit, state = _ref.state;
          if (!(state.currentUser && state.currentUser.isExist())) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", state.currentUser);
        case 1:
          _context.next = 2;
          return User.currentUser();
        case 2:
          user = _context.sent;
          commit('users/setCurrentUser', user, {
            root: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCurrentUser(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var setCurrentUser = function setCurrentUser(vuex, user) {
  var commit = vuex.commit;
  commit('users/setCurrentUser', user, {
    root: true
  });
};
export var destroyCurrentUser = function destroyCurrentUser(_ref3, payload) {
  var commit = _ref3.commit,
    state = _ref3.state;
  commit('users/setCurrentUser', null, {
    root: true
  });
  commit('customer/reset', null, {
    root: true
  });
  commit('applications/reset', null, {
    root: true
  });
  commit('loans/reset', null, {
    root: true
  });
  commit('cards/reset', null, {
    root: true
  });
  commit('transactions/reset', null, {
    root: true
  });
};